<template>
  <v-container fluid pt-0>
    <div class="Chart__list mb-4">
      <div class="Chart">
        <v-img
          src="https://844aa8d177dcf87d02fc-8f72bb99f02c2e7ec80fe67c19b57c36.ssl.cf1.rackcdn.com/newsite/TCClogo_website.png"
          max-height="50"
          contain
          class="grey lighten-3"
        ></v-img>
        <bar-chart
          v-if="loaded"
          :chartData="chartData"
          :options="chartOptions"/>
      </div>
      <div>
        <vue-good-table
          :columns="columns"
          :rows="rows">
          <template slot="table-column" slot-scope="props" class="vgt-center-align">
            <span v-if="props.column.field !='id'" class="body-2 font-weight-bold">
                <v-avatar
                  size="32px"
                >
                  <img
                    :src="props.column.employee.image"
                    alt="Avatar"
                  >
                </v-avatar>
                {{props.column.label}}
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
          </template>
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'id'">
              <span v-if="props.row.id == 'Calls (Outbound)'">
                <span class="body-1" style="font-weight: bold; color: #0d4d66;">{{props.row.id}}</span>
              </span>
              <span v-if="props.row.id == 'Calls (Inbound)'">
                <span class="body-1" style="font-weight: bold; color: #e04326;">{{props.row.id}}</span>
              </span>
              <span v-if="props.row.id == 'Time (Outbound)'">
                <span class="body-1" style="font-weight: bold; color: #5bc8db;">{{props.row.id}}</span>
              </span>
              <span v-if="props.row.id == 'Time (Inbound)'">
                <span class="body-1" style="font-weight: bold; color: #fbb040;">{{props.row.id}}</span>
              </span>
              <span v-if="props.row.id == 'TOTAL CALLS'">
                <span class="body-1" style="font-weight: bold;">{{props.row.id}}</span>
              </span>
              <span v-if="props.row.id == 'TOTAL TIME'">
                <span class="body-1" style="font-weight: bold;">{{props.row.id}}</span>
              </span>
            </span>
            <span v-else-if="props.row.id == 'TOTAL CALLS'">
              <span v-if="props.formattedRow[props.column.field] >= awardCall">
                <v-icon style="font-weight: bold; color: #f4a146;">mdi-trophy</v-icon>
                <span class="body-1" style="font-weight: bold; color: #f4a146;">{{props.formattedRow[props.column.field]}}</span>
              </span>
              <span v-else>
                <span class="body-1" style="font-weight: bold;">{{props.formattedRow[props.column.field]}}</span>
              </span>
            </span>
            <span v-else-if="props.row.id == 'TOTAL TIME'">
              <span v-if="props.formattedRow[props.column.field] >= awardTime">
                <v-icon style="font-weight: bold; color: #f4a146;">mdi-trophy</v-icon>
                <span class="body-1" style="font-weight: bold; color: #f4a146;">{{props.formattedRow[props.column.field]}}</span>
              </span>
              <span v-else>
                <span class="body-1" style="font-weight: bold;">{{props.formattedRow[props.column.field]}}</span>
              </span>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
    </div>
    <v-footer
      height="auto"
      class="tcc-orange-bg"
      fixed
    >
      <v-layout
        justify-center
        row
        wrap
      >
        <v-flex
          class="tcc-orange-bg"
          lighten-2
          py-3
          text-md-center
          white--text
          xs12
        >
          Last update: {{ updated }} 
        </v-flex>
      </v-layout>
    </v-footer>
  </v-container>
</template>

<script>
import axios from 'axios'
import BarChart from '@/charts/BarChart.js'
import moment from 'moment'
import { VueGoodTable } from 'vue-good-table'
import 'vue-good-table/dist/vue-good-table.css'

export default {
  name: 'barchart',

  components: {
    BarChart,
    VueGoodTable
  },

  data: () => ({
    loaded: false,
    columns: [],
    rows: [],
    updated: '',
    employees: [],
    awardCall: '125',
    awardTime: '3:15:00',
    chartData: {
      labels: [],
      datasets: [
        {
          label: 'Calls (Outbound)',
          stack: 'Stack 0',
          yAxisID: 'A',
          type: 'bar',
          borderColor: '#0d4d66',
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: 'white',
          backgroundColor: '#0d4d66',
          data: []
        },{
          label: 'Calls (Inbound)',
          stack: 'Stack 0',
          yAxisID: 'A',
          type: 'bar',
          borderColor: '#e04326',
          pointBackgroundColor: 'white',
          borderWidth: 1,
          pointBorderColor: 'white',
          backgroundColor: '#e04326',
          data: []
        },{
          label: 'Time (Outbound)',
          stack: 'Stack 1',
          yAxisID: 'B',
          type: 'bar',
          borderColor: '#5bc8db',
          pointBackgroundColor: 'black',
          pointBorderColor: 'white',
          borderWidth: 1,
          backgroundColor: '#5bc8db',
          data: []
        },{
          label: 'Time (Inbound)',
          stack: 'Stack 1',
          yAxisID: 'B',
          type: 'bar',
          borderColor: '#fbb040',
          pointBackgroundColor: 'black',
          pointBorderColor: 'white',
          borderWidth: 1,
          backgroundColor: '#fbb040',
          data: []
        }
      ]
    },
    chartOptions: {
      tooltips: {
        enabled: true
      },
      responsive: true,
      maintainAspectRatio: false,
      scales: {
        xAxes: [{
          stacked: true,
          categoryPercentage: 0.5,
          barPercentage: 1
        }],
        yAxes: [
          {
            stacked: true,
            id: 'A',
            scaleLabel: {
              display: true,
              labelString: 'Number of Calls'
            },
            type: 'linear',
            position: 'left'
          },
          {
            stacked: true,
            id: 'B',
            scaleLabel: {
              display: true,
              labelString: 'Time on Calls (seconds)'
            },
            gridLines: {
                display:false
            },
            type: 'linear',
            position: 'right'
          }
        ]
      }
    },
  }),

  created () {
    this.loaded = false

    this.getEmployees()
    this.getLogs()
  },

  methods: {
    formatSeconds (seconds) {
      let hours = Math.floor(seconds / 3600)
      let minutes = Math.floor((seconds - (hours * 3600)) / 60)
      let secondsLeft = seconds - (hours * 3600) - (minutes * 60)

      if (hours < 10) {
        hours = '0' + hours
      }
      if (minutes < 10) {
        minutes = '0' + minutes
      }
      if (secondsLeft < 10) {
        secondsLeft = '0' + secondsLeft
      }

      return hours + ':' + minutes + ':' + secondsLeft
    },
    async getLogs () {
      try {
        const response = await axios.get(`${process.env.API_ENDPOINT}/get_data`)
        this.updated = new Date().toLocaleTimeString()
        // START DATA TRANSFORM AND DEBUGGING
        const logs = response.data
        const salesPeopleInLogs = logs
        .reduce((acc, log) => {
          if (!acc.includes(log.fromName)) acc.push(log.fromName)
          return acc
        }, [])
        .filter(fullName => {
          const employeeData = this.employees.find(employeeData => employeeData.name === fullName)
          return employeeData !== undefined
        })

        // START EXTRACT INBOUND AND OUTBOUND CALL DATA 

        const outboundCounts = Object.assign({}, ...salesPeopleInLogs.map(fullName => {
          const count = logs.reduce((acc, log) => {
            if (log.fromName === fullName && log.direction === 'Outbound') {
              acc += 1
            }
            return acc
          }, 0)
          return {[fullName.split(' ')[0]]: count}
        }))

        const inboundCounts = Object.assign({}, ...salesPeopleInLogs.map(fullName => {
          const count = logs.reduce((acc, log) => {
            if (log.fromName === fullName && log.direction === 'Inbound') {
              acc += 1
            }
            return acc
          }, 0) 
          return {[fullName.split(' ')[0]]: count}
        }))

        const totalCounts = Object.assign({}, ...salesPeopleInLogs.map(fullName => {
          const count = logs.reduce((acc, log) => {
            acc += log.fromName === fullName ? 1 : 0
            return acc
          }, 0)
          return {[fullName.split(' ')[0]]: count}
        }))
        
        const outboundTimeTotals = Object.assign({}, ...salesPeopleInLogs.map(fullName => {
          const count = logs.reduce((acc, log) => {
            if (log.fromName === fullName && log.direction === 'Outbound') {
              acc += log.duration
            }
            return acc
          }, 0)
          return {[fullName.split(' ')[0]]: count}
        }))

        const inboundTimeTotals = Object.assign({}, ...salesPeopleInLogs.map(fullName => {
          const count = logs.reduce((acc, log) => {
            if (log.fromName === fullName && log.direction === 'Inbound') {
              acc += log.duration
            }
            return acc
          }, 0)          
          return {[fullName.split(' ')[0]]: count}
        }))
        const totalTimes = Object.assign({}, ...salesPeopleInLogs.map(fullName => {
          const count = logs.reduce((acc, log) => {
            acc += log.fromName === fullName ? log.duration : 0
            return acc
          }, 0)
          return {[fullName.split(' ')[0]]: count}
        }))

        // END EXTRACT INBOUND AND OUTBOUND CALL DATA

        // START LOAD OUTBOUND AND INBOUND CALLS TO TABLE DATA
        this.columns = [{field: 'id'}]
        for(let employeeName of salesPeopleInLogs) {
          const employeeData = this.employees.find(employeeData => employeeData.name === employeeName)
          if(employeeData === undefined) continue

          this.columns.push({
            field: employeeName.split(' ')[0],
            employee: employeeData,
            html: true,
            label: employeeName.split(' ')[0],
            tdClassFunc: this.tdClassFunc

          })
        }

        const rowIds = [ 
          {id: 'Calls (Outbound)'},
          {id: 'Calls (Inbound)'},
          {id: 'TOTAL CALLS'},
          {id: 'Time (Outbound)'},
          {id: 'Time (Inbound)'},
          {id: 'TOTAL TIME'}
        ]
        // The order of this array is important
        // because the next function maps over the order of salesPeopleInLogs

        // Map over the times to give correct formatting
        const outboundTimeTotalsFormatted = Object.assign({}, ...Object.keys(outboundTimeTotals).map(key => {
          return {[key]: this.formatSeconds(outboundTimeTotals[key])}
        }))
        const inboundTimeTotalsFormatted = Object.assign({}, ...Object.keys(inboundTimeTotals).map(key => {
          return {[key]: this.formatSeconds(inboundTimeTotals[key])}
        }))
        const totalTimesFormatted = Object.assign({}, ...Object.keys(totalTimes).map(key => {
          return {[key]: this.formatSeconds(totalTimes[key])}
        }))

        // Build the rows!
        this.rows = rowIds.map(row => {
          for(let employee of salesPeopleInLogs) {
            if(row.id == 'Calls (Outbound)') {
              row = Object.assign({}, row, outboundCounts)
            }
            if(row.id == 'Calls (Inbound)') {
              row = Object.assign({}, row, inboundCounts)
            }
            if(row.id == 'TOTAL CALLS') {
              row = Object.assign({}, row, totalCounts)
            }
            if(row.id == 'Time (Outbound)') {
              row = Object.assign({}, row, outboundTimeTotalsFormatted)
            }
            if(row.id == 'Time (Inbound)') {
              row = Object.assign({}, row, inboundTimeTotalsFormatted)
            }
            if(row.id == 'TOTAL TIME') {
              row = Object.assign({}, row, totalTimesFormatted)
            }
          }
          return row
        })  
        // END LOAD OUTBOUND AND INBOUND CALLS TO TABLE DATA

        this.chartData.labels = salesPeopleInLogs
        this.chartData.datasets[0].data = Object.values(outboundCounts)
        this.chartData.datasets[1].data = Object.values(inboundCounts)
        this.chartData.datasets[2].data = Object.values(outboundTimeTotals)
        this.chartData.datasets[3].data = Object.values(inboundTimeTotals)

        this.loaded = true
      } catch (e) {
        console.error(e)
      }
    },

    async getEmployees () {
      try {
        const response = await axios.get(`${process.env.API_ENDPOINT}/employees`)
        this.employees = response.data
      } catch (e) {
        console.error(e)
      }
    },

    tdClassFunc(row) {
      return 'vgt-center';
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BarChart.vue